// extracted by mini-css-extract-plugin
export var activeThumbnail = "ProductImages-mps-module--activeThumbnail--56c8e";
export var customDots = "ProductImages-mps-module--customDots--66bb4";
export var desktopImage = "ProductImages-mps-module--desktopImage--204ee";
export var mobileImage = "ProductImages-mps-module--mobileImage--9263f";
export var mobilePagination = "ProductImages-mps-module--mobilePagination--ce402";
export var mobileSlider = "ProductImages-mps-module--mobileSlider--1796b";
export var productImageActive = "ProductImages-mps-module--productImageActive--326c4";
export var productImageThumb = "ProductImages-mps-module--productImageThumb--7ad69";